import { Categories } from "@/utils/lomakkeet";
import { isAdded, isRemoved } from "@/css/label";
import { __ } from "i18n-for-browser";

const labelStyles = {
  addition: isAdded,
  removal: isRemoved
};

export function getToimintaAlueEsivalinnat(
  data: Record<string, unknown>
): Categories {
  return [
    {
      anchor: "esivalinnat",
      categories: [
        {
          anchor: "noudatetaan",
          components: [
            {
              anchor: "A",
              name: "RadioButtonWithLabel",
              properties: {
                isChecked: !data.isToimintaAlueMaaraykset,
                labelStyles,
                title: __("tuva.noudatetaanToimintaAluetta")
              }
            }
          ],
          layout: { indentation: "none" }
        },
        {
          anchor: "ei-noudateta",
          components: [
            {
              anchor: "A",
              name: "RadioButtonWithLabel",
              properties: {
                isChecked: data.isToimintaAlueMaaraykset,
                labelStyles,
                title: __("tuva.toimintaAlueMaaritetaanErikseen")
              }
            }
          ],
          layout: { indentation: "none" }
        }
      ],
      layout: { indentation: "none" }
    }
  ];
}
